import {v4 as uuidv4} from 'uuid';

export const genUuid = ({prefix = '', randomLength = 8} = {}) => {
    const prefixFinal = prefix ? `${prefix}-` : '';
    return `${prefixFinal}${uuidv4().replace(/-/g, '').slice(0, randomLength)}`;
};
